import { Breakpoint, useMediaQuery, useTheme } from "@mui/material";

export function useBetterMediaQuery(breakpoint: Breakpoint): boolean {
	const theme = useTheme();
	return useMediaQuery(theme.breakpoints.up(breakpoint));
}
